'use strict';

const observers = new Map();
const domElements = new WeakMap();

/**
 * Get or create interaction observer
 *
 * @param {String} name
 * @param {Object} opt - observer options
 * @return {IntersectionObserver}
 * @private
 */
function _getOrCreate(name, opt) {
    if (!observers.get(name)) {
        observers.set(name, new IntersectionObserver(_checkIntersection(name, opt.triggerThreshold), opt));
    }

    return observers.get(name);
}

/**
 * Callback when interactions occur
 * @return {Function}
 * @param {string} name
 * @param {number} threshold for trigger
 * @private
 */
function _checkIntersection(name, threshold = 0) {
    return function(entries) {
        let filteredEntries = entries.filter(entry => {
            return entry.intersectionRatio > threshold ? entry : null;
        });

        const observer = observers.get(name);

        filteredEntries.forEach((entry) => {
            const component = domElements.get(entry.target);

            if (!component) {
                return;
            }

            component.setState({ isVisible: true });

            observer.unobserve(entry.target);
            domElements.delete(entry.target);
        });
    };
}

/**
 * Register new component to be observed
 * @param {Component} component - the reactcomponent to be watched
 * @param {String} name - specific observer to attach the component listener to
 * @param {Object} opt - InteractionObserver options
 * @param {DOMElement} element -  Element to observe
 */
function register(component, name, opt, element) {
    opt = opt || null;
    const observer = _getOrCreate(name, opt);
    const elm = element || component.refs.root;
    observer.observe(elm);
    domElements.set(elm, component);
}

/**
 * Unregister observer for component
 *
 * @param {Component} component
 */
function unregister(component) {
    domElements.delete(component.refs.root);
}

export {
    register,
    unregister,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/channeled-interactionobserver.js